import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LoadingContainer } from "@faire/retailer-visitor-shared/views/product/__internal__/styled";
import { Column, Flex, HorizontalLine, Row } from "@faire/web--source/slate/Layout";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";
export var ProductLoadingSkeleton = function() {
    var _useViewport = useViewport(), isTabletAndAbove = _useViewport.isTabletAndAbove, isDesktopAndAbove = _useViewport.isDesktopAndAbove;
    var headerSkeleton = isDesktopAndAbove ? /*#__PURE__*/ _jsx(StickyBrandHeaderSkeleton, {}) : /*#__PURE__*/ _jsx(BreadcrumbSkeleton, {});
    return /*#__PURE__*/ _jsx(Wrapper, {
        children: /*#__PURE__*/ _jsx(StyledLoadingContainer, {
            children: /*#__PURE__*/ _jsxs(Column, {
                children: [
                    isTabletAndAbove ? /*#__PURE__*/ _jsx(_Fragment, {
                        children: headerSkeleton
                    }) : null,
                    /*#__PURE__*/ _jsxs(RowMobileColumn, {
                        children: [
                            /*#__PURE__*/ _jsx(Column, {
                                flex: 1,
                                children: /*#__PURE__*/ _jsxs(ImageGridContainer, {
                                    children: [
                                        /*#__PURE__*/ _jsx(SquareLoadingSkeleton, {
                                            $numLabel: 0
                                        }),
                                        isTabletAndAbove ? /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(SquareLoadingSkeleton, {
                                                    $numLabel: 1
                                                }),
                                                /*#__PURE__*/ _jsx(SquareLoadingSkeleton, {
                                                    $numLabel: 2
                                                }),
                                                /*#__PURE__*/ _jsx(SquareLoadingSkeleton, {
                                                    $numLabel: 3
                                                })
                                            ]
                                        }) : null
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: useResponsiveValue({
                                    mobileAndAbove: "2x",
                                    tabletAndAbove: "5x"
                                })
                            }),
                            /*#__PURE__*/ _jsxs(ProductDetailsContainer, {
                                children: [
                                    !isDesktopAndAbove ? /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsxs(Row, {
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                                                        width: "40px",
                                                        height: "40px",
                                                        borderRadius: "50%"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Spacer, {
                                                        width: "1x"
                                                    }),
                                                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                                                        width: "160px",
                                                        height: "20px"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Spacer, {
                                                height: "3x"
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                                        width: "100%",
                                        height: "32px"
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        height: "2x"
                                    }),
                                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                                        width: "100%",
                                        height: "24px"
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        height: "3x"
                                    }),
                                    /*#__PURE__*/ _jsxs(Row, {
                                        justify: "space-between",
                                        children: [
                                            /*#__PURE__*/ _jsx(LoadingSkeleton, {
                                                width: "64px",
                                                height: "8px"
                                            }),
                                            /*#__PURE__*/ _jsx(LoadingSkeleton, {
                                                width: "64px",
                                                height: "8px"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        height: 4
                                    }),
                                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                                        width: "100%",
                                        height: "40px"
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        height: "2x"
                                    }),
                                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                                        width: "100%",
                                        height: "40px"
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        height: "8x"
                                    }),
                                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                                        width: "64px",
                                        height: "8px"
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        height: "2x"
                                    }),
                                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                                        width: "200px",
                                        height: "8px"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var StickyBrandHeaderSkeleton = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: 12
            }),
            /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "1x"
                    }),
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: "200px",
                        height: "20px"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: 12
            })
        ]
    });
};
var BreadcrumbSkeleton = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: 12
            }),
            /*#__PURE__*/ _jsx(LoadingSkeleton, {
                width: "400px",
                height: "20px"
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: 12
            }),
            /*#__PURE__*/ _jsx(HorizontalLine, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "5x"
            })
        ]
    });
};
var Wrapper = styled(Column).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-d393aa7a-0"
})([
    "width:100%;"
]);
var StyledLoadingContainer = styled(LoadingContainer).withConfig({
    componentId: "sc-d393aa7a-1"
})([
    "max-width:1280px;padding:",
    ";",
    "{padding:0;}"
], getSpacing(0, "6x"), responsiveMediaQueries.mobile);
var ProductDetailsContainer = styled(Column).withConfig({
    componentId: "sc-d393aa7a-2"
})([
    "width:360px;",
    "{width:300px;}",
    "{padding:",
    ";width:100%;}"
], responsiveMediaQueries.tablet, responsiveMediaQueries.mobile, getSpacing(0, "2x"));
var ImageGridContainer = styled.div.withConfig({
    componentId: "sc-d393aa7a-3"
})([
    'display:grid;grid-template:"skeleton-0 skeleton-1" auto "skeleton-2 skeleton-3" auto;gap:4px;',
    '{grid-template:"skeleton-0 skeleton-0" auto "skeleton-1 skeleton-2" auto "skeleton-3 skeleton-3" auto;}',
    "{display:flex;}"
], responsiveMediaQueries.tablet, responsiveMediaQueries.mobile);
var SquareLoadingSkeleton = styled(LoadingSkeleton).attrs({
    width: "100%",
    height: "100%"
}).withConfig({
    componentId: "sc-d393aa7a-4"
})([
    "aspect-ratio:1/1;grid-area:",
    ";"
], function(props) {
    return "skeleton-".concat(props.$numLabel);
});
var RowMobileColumn = styled(Flex).attrs({
    direction: {
        mobileAndAbove: "column",
        tabletAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-d393aa7a-5"
})([
    ""
]);
